<template>
  <div class="">
    <div class="modal fade" id="addressModal" tabindex="-1" role="dialog" aria-labelledby="addressModal"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-scrollable modal-lg" role="document">
        <div class="modal-content py-2 px-3 px-md-5">
          <div class="modal-header">
            <h5 class="modal-title" id="addressModalLabel"
              v-if="!addClicked && !editClicked && !mellisaValidationModal">
              {{ $resourceString["checkout.Address.Modal"] }}
            </h5>
            <h5 class="modal-title" v-if="mellisaValidationModal">
              {{ $resourceString["checkout.Address.VerifyAddress.Modal"] }}
            </h5>
            <h5 v-if="addClicked && !mellisaValidationModal" class="modal-title" id="addressModalLabel">
              {{ $resourceString["checkout.Address.NewAddress.Modal"] }}
            </h5>
            <h5 v-if="editClicked && !mellisaValidationModal" class="modal-title" id="addressModalLabel">
              {{ $resourceString["checkout.Address.EditAddress.Modal"] }}
            </h5>
            <button class="wf-modal-button-close btn button-full" type="button" data-dismiss="modal" aria-label="Close"
              ref="closeModal" @click="exitNewModal">
              <span class="png-icon png-icon-icons-symbols--k-txtclose" aria-label="Close modal" />
            </button>
          </div>
          <div class="modal-body">
            <div class="row d-block d-lg-none">
              <div class="col-12 mb-2">
                <button v-if="!addClicked && !editClicked && !mellisaValidationModal"
                  class="wf-add-to-cart-button btn btn-outline-danger justify-content-center w-100" type="button"
                  @click="addressModalAction(0)">
                  {{ $resourceString["checkout.Button.AddNewAddress"] }}
                </button>
                <button v-if="addClicked || editClicked"
                  class="wf-add-to-cart-button btn btn-outline-danger justify-content-center w-100" type="button"
                  @click="showAddressList()">
                  {{ $resourceString["checkout.AddressVerification.Modal.AddressList"] }}
                </button>
              </div>
            </div>
            <div class="row" v-if="!addClicked && !editClicked && !mellisaValidationModal">
              <div v-for="(address, index) in addresses" :key="address.id" :value="index" class="col-12 col-lg-6">
                <div @click="addressSelected(index)" :class="index == addressId ? 'border border-danger rounded' : ''"
                  class="bg-light p-3 font-24 text-capitalize">
                  <div class="font-weight-bold mb-2">
                    {{ address.company }}
                  </div>
                  <div class="m-0">
                    {{ address.firstName }} {{ address.lastName }}
                  </div>
                  <div class="m-0">
                    {{ address.streetLine2 ? address.streetLine1 + ", Suite" + address.streetLine2 :
                    address.streetLine1}}
                  </div>
                  <div class="m-0">{{ address.city }} {{ address.state }} {{ address.postalCode }}</div>
                  <div class="m-0">
                    {{ address.country }}
                    {{
                      address.isDefault
                        ? ` (${$resourceString["common.Label.Default"]})`
                        : !getIsDefaultSelected && address.isB2cAddress
                          ? ` (${$resourceString["common.Label.Default"]})`
                          : ""
                    }}                    
                  </div>
                  <hr />
                  <div class="w-100 mb-3 font-16">
                    <a href="#" class="float-left" v-show="index == addressId" @click="addressModalAction(1)">
                      {{ $resourceString["checkout.AddressVerification.Suggestion.EditButton"] }}
                    </a>
                    <a href="#" class="float-right"
                      v-if="!inputAddress.isDefault && !inputAddress.isB2cAddress && index == addressId"
                      @click="removeSelectedUserAddress(address.id)">
                      {{
                        $resourceString["checkout.Address.Button.RemoveAddress"]
                      }}
                    </a>
                  </div>
                </div>
                <br />
              </div>
            </div>
            <div v-show="(addClicked || editClicked) && !mellisaValidationModal">
              <div class="row">
                <div class="col-lg-6 col-12">
                  <label class="font-16 font-weight-bold" for="fname">
                    {{ $resourceString["checkout.Address.Label.Fname"] }}
                  </label>
                  <input class="shipping-modal-input-field form-control" :class="checkoutData.FieldClasses &&
                      checkoutData.FieldClasses.FirstName
                      ? checkoutData.FieldClasses.FirstName
                      : ''
                    " type="text" id="fname" name="fname" :placeholder="$resourceString['checkout.Address.Placeholder.FirstName']" required maxlength="100"
                    v-model="inputAddress['firstName']" />
                  <div v-if="validationError.firstName" class="text-danger font-16">
                    {{ validationError.firstName }}  
                  </div>
                </div>
                <div class="col-lg-6 col-12">
                  <label class="font-16 font-weight-bold" for="lname">
                    {{ $resourceString["checkout.Address.Label.Lname"] }}
                  </label>
                  <input class="shipping-modal-input-field form-control" :class="checkoutData.FieldClasses &&
                      checkoutData.FieldClasses.FastName
                      ? checkoutData.FieldClasses.FastName
                      : ''
                    " type="text" id="lname" name="lname" :placeholder="$resourceString['checkout.Address.Placeholder.LastName']" required maxlength="100"
                    v-model="inputAddress['lastName']" />
                  <div v-if="validationError.lastName" class="text-danger font-16">
                    {{ validationError.lastName }}
                  </div>
                </div>
                <br />
              </div>
              <div class="row">
                <div class="col-lg-6 col-12">
                  <label class="font-16 font-weight-bold mt-2" for="country">{{
                    $resourceString["checkout.Address.Label.Country"]
                  }}</label>
                  <select class="shipping-modal-input-field form-control" :class="checkoutData.FieldClasses &&
                      checkoutData.FieldClasses.Country
                      ? checkoutData.FieldClasses.Country
                      : ''
                    " id="country" name="country" @change="countrySelected()" required
                    v-model="inputAddress['country']">
                    <option v-for="country in countryData" :key="country.Value" :value="country.Value">
                      {{ country.Text }}
                    </option>
                  </select>
                  <div v-if="validationError.country" class="text-danger font-16">
                    {{ validationError.country }}
                  </div>
                </div>
                <br />
              </div>
              <div class="row">
                <div class="col-lg-6 col-12">
                  <label class="font-16 font-weight-bold mt-2" for="addressLine1">
                    {{ $resourceString["checkout.Address.Label.Address"] }}
                  </label>
                  <input class="shipping-modal-input-field form-control" :class="checkoutData.FieldClasses &&
                      checkoutData.FieldClasses.AddressLine1
                      ? checkoutData.FieldClasses.AddressLine1
                      : ''
                    " type="text" id="addressLine1" name="addressLine1" ref="addressLine1" :placeholder="$resourceString['checkout.Address.Placeholder.AddressOne']"
                    v-model="inputAddress['streetLine1']" />
                  <div v-if="validationError.streetLine1" class="text-danger font-16">
                    {{ validationError.streetLine1 }}
                  </div>
                </div>

                <div class="col-lg-6 col-12">
                  <label class="font-16 font-weight-bold mt-2" for="suite">
                    {{ $resourceString["checkout.Address.Label.Suite"] }}
                  </label>
                  <input class="shipping-modal-input-field form-control" :class="checkoutData.FieldClasses &&
                      checkoutData.FieldClasses.Suite
                      ? checkoutData.FieldClasses.Suite
                      : ''
                    " type="text" id="suite" name="suite" :placeholder="$resourceString['checkout.Address.Placeholder.Suite']" v-model="inputAddress['suite']"
                    maxlength="100" />
                </div>
                <br />
              </div>
              <div class="row">
                <div class="col-lg-6 col-12">
                  <label class="font-16 font-weight-bold mt-2" for="city">
                    {{ $resourceString["checkout.Address.Label.City"] }}
                  </label>
                  <input class="shipping-modal-input-field form-control" :class="checkoutData.FieldClasses &&
                      checkoutData.FieldClasses.City
                      ? checkoutData.FieldClasses.City
                      : ''
                    " type="text" id="city" name="city" :placeholder="$resourceString['checkout.Address.Placeholder.City']" v-model="inputAddress['city']" required
                    maxlength="100" />
                  <div v-if="validationError.city" class="text-danger font-16">
                    {{ validationError.city }}
                  </div>
                </div>
                <div class="col-lg-6 col-12">
                  <label class="font-16 font-weight-bold mt-2">
                    {{ $resourceString["checkout.Address.Label.PostalCode"] }}
                  </label>
                  <input class="shipping-modal-input-field form-control" :class="checkoutData.FieldClasses &&
                      checkoutData.FieldClasses.PostalCode
                      ? checkoutData.FieldClasses.PostalCode
                      : ''
                    " type="text" id="pcode" name="pcode" :placeholder="$resourceString['checkout.Address.Placeholder.PostalCode']"
                    v-model="inputAddress['postalCode']" required maxlength="20" />
                  <div v-if="validationError.postalCode" class="text-danger font-16">
                    {{ validationError.postalCode }}
                  </div>
                </div>
                <br />
              </div>
              <div class="row">
                <div class="col-lg-6 col-12">
                  <label class="font-16 font-weight-bold mt-2" for="stateprovince">
                    {{ $resourceString["checkout.Address.Label.State"] }}
                  </label>
                  <select class="shipping-modal-input-field form-control" :class="checkoutData.FieldClasses &&
                      checkoutData.FieldClasses.State
                      ? checkoutData.FieldClasses.State
                      : ''
                    " id="stateprovince" name="stateprovince" v-model="inputAddress['state']" required>
                    <option v-for="state in countryState" :key="state.code" :value="state.code">
                      {{ state.name }}
                    </option>
                  </select>
                  <div v-if="validationError.state" class="text-danger font-16">
                    {{ validationError.state }}
                  </div>
                </div>
                <div class="col-lg-6 col-12">
                  <label class="font-16 font-weight-bold mt-2" for="company">
                    {{ $resourceString["checkout.Address.Label.Company"] }}
                  </label>
                  <input class="shipping-modal-input-field form-control" :class="checkoutData.FieldClasses &&
                      checkoutData.FieldClasses.Company
                      ? checkoutData.FieldClasses.Company
                      : ''
                    " type="text" id="company" name="company" :placeholder="$resourceString['checkout.Address.Placeholder.Company']" v-model="inputAddress['company']"
                    required maxlength="100" />
                  <div v-if="validationError.company" class="text-danger font-16">
                    {{ validationError.company }}
                  </div>
                </div>
                <br />
              </div>
              <div class="row">
                <div class="col-lg-6 col-12">
                  <label class="font-16 font-weight-bold mt-2" for="email">
                    {{ $resourceString["checkout.Address.Label.Email"] }}
                  </label>
                  <input class="shipping-modal-input-field form-control" :class="checkoutData.FieldClasses &&
                      checkoutData.FieldClasses.Email
                      ? checkoutData.FieldClasses.Email
                      : ''
                    " type="email" id="email" name="email" :placeholder="$resourceString['checkout.Address.Placeholder.ContactEmail']" required maxlength="45"
                    v-model="inputAddress['email']" />
                  <div v-if="validationError.email" class="text-danger font-16">
                    {{ validationError.email }}
                  </div>
                </div>
                <div class="col-lg-6 col-12">
                  <label class="font-16 font-weight-bold mt-2">{{
                    $resourceString["checkout.Address.Label.Phone"]
                  }}</label>
                  <div id="checkout-form" class="form-group position-relative mb-0">
                    <input class="shipping-modal-input-field form-control text-box single-line" :class="checkoutData.FieldClasses &&
                        checkoutData.FieldClasses.Phone
                        ? checkoutData.FieldClasses.Phone
                        : ''
                      " type="tel" id="phone" name="phone" :placeholder="$resourceString['checkout.Address.Placeholder.Phone']" v-model="inputAddress['cellPhone']"
                      required minlength="17" maxlength="20" />
                    <div class="custom-tooltip">
                      <i class="tooltip-icon">?</i>
                      <span class="tooltip-text arrow-down">
                        {{
                          $resourceString[
                          "checkout.Address.PhoneNumber.Tooltip"
                          ]
                        }}
                      </span>
                    </div>
                  </div>
                  <div v-if="validationError.cellPhone" class="text-danger font-16">
                    {{ validationError.cellPhone }}
                  </div>
                </div>
                <br />
              </div>
              <div class="row">
                <div class="col-12">
                  <input class="mt-2" type="checkbox" id="defaultaddresscheckbox" name="defaultaddress"
                    v-model="inputAddress['isDefault']" />
                  <label for="defaultaddress" class="mt-4 font-16 font-weight-bold">
                    {{
                      $resourceString["checkout.Address.Label.DefaultAddress"]
                    }}
                  </label>
                </div>
              </div>
            </div>

            <form v-if="mellisaValidationModal">
              <p v-if="getMellisaValidation.status == 'Changed'">
                {{
                  $resourceString["checkout.Address.MellisaValidation.Changed"]
                }}
              </p>
              <p v-if="getMellisaValidation.status == 'Invalid'">
                {{
                  $resourceString["checkout.Address.MellisaValidation.InValid"]
                }}
              </p>
              <div class="row">
                <div class="col-lg-6 col-12">
                  <p>
                    {{
                      $resourceString[
                      "checkout.Address.MellisaValidation.OriginalAddress"
                      ]
                    }}
                  </p>

                  <div class="bg-light p-3 font-24 text-capitalize" @click="addressConfirmation(0)" :class="currentSelectedAddress == 0
                      ? 'border border-danger rounded'
                      : ''
                    ">
                    <div class="m-0">
                      {{ inputAddress.firstName }}
                      {{ inputAddress.lastName }}
                    </div>
                    <div class="m-0">
                      {{ inputAddress.streetLine1 }}
                    </div>
                    <div class="m-0">
                      {{ inputAddress.city }}
                      {{ inputAddress.state }}
                      {{ inputAddress.postalCode }}
                    </div>
                    <div class="m-0">{{ inputAddress.country }}</div>
                  </div>
                </div>
                <div class="col-lg-6 col-12" v-if="this.getMellisaValidation.status != 'Invalid'">
                  <p>
                    {{
                      $resourceString[
                      "checkout.Address.MellisaValidation.SuggestedAddress"
                      ]
                    }}
                  </p>

                  <div class="bg-light p-3 font-24 text-capitalize" @click="addressConfirmation(1)" :class="currentSelectedAddress == 1
                      ? 'border border-danger rounded'
                      : ''
                    ">
                    <div class="m-0">
                      {{ inputAddress.firstName }}
                      {{ inputAddress.lastName }}
                    </div>
                    <div class="mb-1" :class="inputAddress.streetLine1 !=
                        getMellisaValidation.changedAddress.addressLine1
                        ? 'changed-address'
                        : ''
                      ">
                      {{ getMellisaValidation.changedAddress.addressLine1 }}
                    </div>
                    <div class="mb-1">
                      <span :class="inputAddress.city !=
                          getMellisaValidation.changedAddress.locality
                          ? 'changed-address'
                          : ''
                        ">
                        {{ getMellisaValidation.changedAddress.locality }}
                      </span>
                      <span :class="inputAddress.state !=
                          getMellisaValidation.changedAddress.administrativeArea
                          ? 'changed-address'
                          : ''
                        ">
                        {{
                          getMellisaValidation.changedAddress.administrativeArea
                        }}
                      </span>
                      <span :class="inputAddress.postalCode !=
                          getMellisaValidation.changedAddress.postalCode
                          ? 'changed-address'
                          : ''
                        ">
                        {{ getMellisaValidation.changedAddress.postalCode }}
                      </span>
                    </div>
                    <div class="m-0">
                      <span :class="inputAddress.country !=
                          getMellisaValidation.changedAddress.country
                          ? 'changed-address'
                          : ''
                        ">
                        {{ getMellisaValidation.changedAddress.country }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <p class="text-danger" v-if="!showSaveAddressButton">
                  {{
                    $resourceString[
                    "checkout.Address.MellisaValidation.AddressError"
                    ]
                  }}
                </p>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <div class="w-100 row">
              <div class="col-6 d-none d-lg-block">
                <button v-if="!addClicked && !editClicked && !mellisaValidationModal"
                  class="wf-add-to-cart-button btn btn-outline-danger m-1" type="button" @click="addressModalAction(0)">
                  {{ $resourceString["checkout.Button.AddNewAddress"] }}
                </button>
                <button v-if="addClicked || editClicked" class="wf-add-to-cart-button btn btn-outline-danger m-1"
                  type="button" @click="showAddressList()">
                  {{
                    $resourceString[
                    "checkout.AddressVerification.Modal.AddressList"
                    ]
                  }}
                </button>
              </div>
              <div class="col-lg-6 col-12">
                <button v-if="!mellisaValidationModal" @click="validateUserAddress"
                  class="wf-add-to-cart-button btn btn-primary m-1 col-md-6 col-12 justify-content-center"
                  type="button">
                  {{
                    $resourceString[
                    "checkout.AddressVerification.Modal.ValidateButton"
                    ]
                  }}
                </button>
                <button class="wf-add-to-cart-button btn btn-danger m-1 col-md-5 col-12 justify-content-center"
                  type="button" v-if="!mellisaValidationModal" data-dismiss="modal" @click="exitNewModal">
                  {{ $resourceString["checkout.Address.Button.CancelAddress"] }}
                </button>
                <button :disabled="!showSaveAddressButton" v-if="mellisaValidationModal"
                  class="wf-add-to-cart-button btn btn-primary m-1 col-md-5 col-12 justify-content-center" type="button"
                  @click="saveAddress">
                  {{
                    $resourceString[
                    "checkout.AddressVerification.Suggestion.SaveButton"
                    ]
                  }}
                </button>
                <a v-if="mellisaValidationModal" @click="editAddress"
                  class="wf-add-to-cart-button btn btn-primary m-1 col-md-6 col-12 justify-content-center"
                  type="button">
                  {{
                    $resourceString[
                    "checkout.AddressVerification.Suggestion.EditButton"
                    ]
                  }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  computed: {
    ...mapGetters({
      addresses: "newCheckoutPage/addresses",
      countryData: "newCheckoutPage/countryData",
      countryState: "newCheckoutPage/countryState",
      getEditAddressModal: "newCheckoutPage/getEditAddressModal",
      getIsDefaultSelected: "newCheckoutPage/getIsDefaultSelected",
      checkoutData: "newCheckoutPage/checkoutData",
      getAddressErrorValidationFlag: "newCheckoutPage/getAddressErrorValidationFlag",
      validationError: "newCheckoutPage/getValidationError",
      getMellisaValidation: "newCheckoutPage/getMellisaValidation",
      getCurrentAddressOption: "newCheckoutPage/getCurrentAddressOption"
    })
  },
  data() {
    return {
      addressId: 0,
      inputAddress: {
        firstName: "",
        lastName: "",
        streetLine1: "",
        streetLine2: "",
        city: "",
        state: "",
        country: "US",
        postalCode: "",
        cellPhone: "",
        isDefault: false,
        isB2cAddress: false,
        email: "",
        suite: "",
        company: null
      },
      errors: {},
      addressModalType: 1,
      editClicked: false,
      addClicked: false,
      autocomplete: null,
      mellisaValidationModal: false,
      currentSelectedAddress: 1,
      showSaveAddressButton: true
    };
  },
  watch: {
    getMellisaValidation() {
      if (this.getMellisaValidation.status === "Changed" || this.getMellisaValidation.status == "Invalid") {
        this.mellisaValidationModal = true;
        this.addClicked = false;
        this.editClicked = false;
        if (this.getMellisaValidation.status === "Invalid") {
          this.addressConfirmation(0);
        } else {
          this.addressConfirmation(1);
        }
      } else if (this.getMellisaValidation.status === "Valid") {
        this.storeUserAddress();
      }
    },
    getEditAddressModal() {
      this.$refs.editAddressModal.click();
    },
    "inputAddress.cellPhone": function (newValue, oldValue) {
      this.formatPhoneNumber(newValue, oldValue);
    },
    getCurrentAddressOption() {
      this.addressId = this.getCurrentAddressOption.addressIndex;
      this.updateAddressFields();
    }
  },
  methods: {
    ...mapActions({
      fetchAddresses: "newCheckoutPage/fetchAddresses",
      saveUserAddress: "newCheckoutPage/saveUserAddress",
      editUserAddress: "newCheckoutPage/editUserAddress",
      removeUserAddress: "newCheckoutPage/removeUserAddress",
      getCountryStates: "newCheckoutPage/getCountryStates",
      setCurrentAddress: "newCheckoutPage/setCurrentAddress",
      addressValidation: "newCheckoutPage/addressValidation",
      updateErrorValidationDefault: "newCheckoutPage/updateErrorValidationDefault",
      validateUserAddressMellisa: "newCheckoutPage/validateUserAddressMellisa"
    }),
    formatPhoneNumber(newValue, oldValue) {
      let updateNumber = "";
      let length =
        newValue.length === 5 && oldValue.length === 1
          ? 0
          : newValue.length === 6 && oldValue.length === 2
            ? 2
            : newValue.length === 9 && oldValue.length === 4
              ? 3
              : newValue.length === 7 && oldValue.length === 3
                ? 3
                : 11;
      let replaced = newValue.replace(/\D/g, "").substring(0, length);
      let phoneNumber =
        replaced.charAt(0) === "1" && replaced.length > 1
          ? replaced.substr(1)
          : replaced;
      if (phoneNumber.length < 4) {
        updateNumber = phoneNumber.replace(/(\d{1,})/, "+1 ($1)");
      } else if (phoneNumber.length < 7) {
        updateNumber = phoneNumber.replace(/(\d{3})(\d{1,})/, "+1 ($1) $2");
      } else {
        updateNumber = phoneNumber.replace(
          /(\d{3})(\d{3})(\d{1,})/,
          "+1 ($1) $2 $3"
        );
      }
      this.inputAddress.cellPhone = updateNumber;
    },
    addressSelected(selectedAddressIndex) {
      this.addressId = selectedAddressIndex;
      this.updateAddressFields();
    },
    googleAutoComplete() {
      if (this.autocomplete && this.autocomplete.componentRestrictions) {
        this.autocomplete.componentRestrictions.country = this.inputAddress["country"];
      }
      this.autocomplete = new google.maps.places.Autocomplete(this.$refs["addressLine1"],
        {
          types: ["establishment"],
          componentRestrictions: { country: this.inputAddress["country"] },
          fields: ["address_components"]
        }
      );

      this.autocomplete.addListener("place_changed", () => {
        const place = this.autocomplete.getPlace();
        if (!place.address_components) {
          this.$refs["addressLine1"].placeholder = "Enter place";
        } else {
          let buildingNumber = "";
          let streetName = "";
          let city = "";
          let state = "";
          let postalCode = "";

          for (let property in place.address_components) {
            buildingNumber =
              this.getValueFromAddressComponent(
                property,
                "street_number",
                place
              ) ?? buildingNumber;
            streetName =
              this.getValueFromAddressComponent(property, "route", place) ??
              streetName;
            city =
              this.getValueFromAddressComponent(property, "locality", place) ??
              city;
            state =
              this.getValueFromAddressComponent(
                property,
                "administrative_area_level_1",
                place,
                false
              ) ?? state;
            postalCode =
              this.getValueFromAddressComponent(
                property,
                "postal_code",
                place
              ) ?? postalCode;
          }
          this.inputAddress["streetLine1"] = buildingNumber + " " + streetName;
          this.inputAddress["postalCode"] = postalCode;
          this.inputAddress["city"] = city;
          this.inputAddress["state"] = state;
        }
      });
    },
    showAddressList() {
      this.addClicked = false;
      this.editClicked = false;
      this.mellisaValidationModal = false;
    },
    addressModalAction(type) {
      this.addressModalType = type;
      this.updateErrorValidationDefault();
      if (type == 0) {
        this.clearAddressInput();
        this.addClicked = true;
        this.editClicked = false;
      } else {
        this.updateAddressFields();
        this.getCountryStates(this.inputAddress["country"]);
        this.editClicked = true;
        this.addClicked = false;
      }
      this.googleAutoComplete();
    },
    exitNewModal() {
      if (this.addressModalType == 1) {
        this.clearAddressInput();
      }
      this.editClicked = false;
      this.addClicked = false;
      this.mellisaValidationModal = false;
    },
    clearAddressInput() {
      let addressFieldKeys = Object.keys(this.inputAddress);
      addressFieldKeys.forEach(ele => {
        if (ele != "country") {
          this.inputAddress[ele] = "";
        }
      });
    },
    getValueFromAddressComponent(
      property,
      componentName,
      place,
      isLongName = true
    ) {
      if (!place.address_components[property].types.includes(componentName))
        return null;

      return isLongName
        ? place.address_components[property].long_name
        : place.address_components[property].short_name;
    },
    countrySelected() {
      this.googleAutoComplete();
      this.inputAddress["streetLine1"] = "";
      this.inputAddress["streetLine2"] = "";
      this.inputAddress["city"] = "";
      this.inputAddress["postalCode"] = "";
      this.getCountryStates(this.inputAddress["country"]);
    },
    updateAddressFields() {
      let addressFieldKeys = Object.keys(this.addresses[this.addressId]);
      addressFieldKeys.forEach(ele => {
        this.inputAddress[ele] = this.addresses[this.addressId][ele];
      });
      if (!this.getIsDefaultSelected && this.inputAddress["isB2cAddress"]) {
        this.inputAddress["isDefault"] = true;
      }
    },
    async validateUserAddress() {
      if (this.addClicked == false && this.editClicked == false) {
        this.updateAddressFields();
      }
      this.inputValidation();
      if (!this.getAddressErrorValidationFlag) {
        await this.validateUserAddressMellisa(this.inputAddress);
      } else if (
        this.getAddressErrorValidationFlag &&
        !this.addClicked &&
        !this.editClicked
      ) {
        this.addressModalAction(1);
        this.inputValidation();
      }
    },
    async storeUserAddress() {
      this.inputValidation();
      if (!this.getAddressErrorValidationFlag) {
        if (this.inputAddress && this.inputAddress.id) {
          await this.editUserAddress(this.inputAddress);
          this.$refs.closeModal.click();
        } else {
          await this.saveUserAddress(this.inputAddress);
          this.showAddressList();
        }
      }
    },
    async saveAddress() {
      if (this.currentSelectedAddress === 1) {
        this.updateAddress();
      }
      this.storeUserAddress();
      this.showAddressList();
    },
    editAddress() {
      if (this.currentSelectedAddress === 1) {
        this.updateAddress();
      }
      this.mellisaValidationModal = false;
      this.editClicked = true;
    },
    updateAddress() {
      this.inputAddress.streetLine1 = this.getMellisaValidation.changedAddress.addressLine1;
      this.inputAddress.suite = this.getMellisaValidation.changedAddress.addressLine2;
      this.inputAddress.city = this.getMellisaValidation.changedAddress.locality;
      this.inputAddress.state = this.getMellisaValidation.changedAddress.administrativeArea;
      this.inputAddress.postalCode = this.getMellisaValidation.changedAddress.postalCode;
      this.inputAddress.country = this.getMellisaValidation.changedAddress.country;
    },
    inputValidation() {
      this.addressValidation(this.inputAddress);
    },
    async removeSelectedUserAddress(id) {
      await this.removeUserAddress(id);
      this.addressId = 0;
    },
    addressConfirmation(type) {
      this.currentSelectedAddress = type;
      if (this.currentSelectedAddress == 0) {
        if (
          this.inputAddress.country !=
          this.getMellisaValidation.changedAddress.country ||
          this.inputAddress.postalCode !=
          this.getMellisaValidation.changedAddress.postalCode ||
          this.inputAddress.state !=
          this.getMellisaValidation.changedAddress.administrativeArea
        ) {
          this.showSaveAddressButton = false;
        } else {
          this.showSaveAddressButton = true;
        }
      } else {
        this.showSaveAddressButton = true;
      }
    }
  }
};
</script>

<style></style>
